<template>
    <div class="form_group form_group_address" :class="'form_group_'+address_name">
        <display-message :option="message_option"></display-message>
        <div class="form_row">
            <label :for="address_name+'_country'" v-html="cache_data_label.country" v-show="cache_data.country"></label>
            <div class="select_container">
                <select :id="address_name+'_country'" :placeholder="cache_data_label.country" v-model="cache_data.country" @change="reset_cache_data({update_country:true})">
                    <option value="" disabled v-show="!cache_data.country">-- {{ cache_data_label.country }} --</option>
                    <option :value="available_country.value" v-for="available_country in available_countries">{{ available_country.display_name }}</option>
                </select>
            </div>
        </div>
        <p style="font-size: 0.8em;padding:1em 0;margin:0;font-style: italic;">Search for an address below. If your address does not appear, you can enter it manually below</p>
        <div class="form_row">
            <label :for="address_name+ '_formatted_address'">Find an address</label>
            <div class="address_autocomplete_container">
                <input type="text" :id="address_name+ '_formatted_address'" autocomplete="google_autocomplete" @focus="init_autocomplete" v-model="google_autocomplete_input" @change="cache_data.place = null; cache_data.place_id = '';">
            </div>
<!--            <input type="hidden" v-model="cache_data.formatted_address">-->
        </div>
        <p style="font-size: 0.8em;padding:1em 0;margin:0;font-style: italic;">Enter address manually</p>
<!--        <div class="form_row">-->
<!--            <label :for="address_name+ '_formatted_address'" v-html="cache_data_label.formatted_address" v-show="cache_data.formatted_address"></label>-->
<!--            <input type="text" :id="address_name+ '_formatted_address'" :placeholder="cache_data_label.formatted_address" v-model="cache_data.formatted_address" autocomplete="google_autocomplete" @focus="init_autocomplete" @change="cache_data.place = null; cache_data.place_id = '';">-->
<!--        </div>-->
<!--        <div class="form_group">-->
<!--            -->
<!--        </div>-->
        <div class="form_row">
            <label :for="address_name+ '_point_of_interest'" v-html="cache_data_label.point_of_interest" v-show="cache_data.point_of_interest"></label>
            <input type="text" :id="address_name+ '_point_of_interest'" :placeholder="cache_data_label.point_of_interest" v-model="cache_data.point_of_interest" @change="update_formatted_address">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_subpremise'" v-html="cache_data_label.subpremise" v-show="cache_data.subpremise"></label>
            <input type="text" :id="address_name+ '_subpremise'" :placeholder="cache_data_label.subpremise" v-model="cache_data.subpremise" @change="update_formatted_address">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_street_number'" v-html="cache_data_label.street_number" v-show="cache_data.street_number"></label>
            <input type="text" :id="address_name+ '_street_number'" :placeholder="cache_data_label.street_number" v-model="cache_data.street_number" @change="update_formatted_address">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_route'" v-html="cache_data_label.route" v-show="cache_data.route"></label>
            <input type="text" :id="address_name+ '_route'" :placeholder="cache_data_label.route" v-model="cache_data.route" @change="update_formatted_address">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_locality'" v-html="cache_data_label.locality" v-show="cache_data.locality"></label>
            <input type="text" :id="address_name+ '_locality'" :placeholder="cache_data_label.locality" v-model="cache_data.locality" @change="update_formatted_address">
        </div>
        <div class="form_row">
            <label :for="address_name+ '_administrative_area_level_1'" v-html="cache_data_label.administrative_area_level_1" v-show="cache_data.administrative_area_level_1"></label>
            <input type="text" :id="address_name+ '_administrative_area_level_1'" :placeholder="cache_data_label.administrative_area_level_1" v-model="cache_data.administrative_area_level_1" v-show="!available_states[cache_data.country]" @change="update_formatted_address">
            <div class="select_container" v-show="available_states[cache_data.country]">
                <select :id="address_name+ '_administrative_area_level_1'" :placeholder="cache_data_label.administrative_area_level_1" v-model="cache_data.administrative_area_level_1" @change="update_formatted_address">
                    <option value="" disabled v-show="!cache_data.administrative_area_level_1">-- {{ cache_data_label.administrative_area_level_1 }} --</option>
                    <option :value="available_state.value" v-for="available_state in available_states[cache_data.country]">{{ available_state.display_name }}</option>
                </select>
            </div>
        </div>
        <div class="form_row">
            <label :for="address_name+ '_postal_code'" v-html="cache_data_label.postal_code" v-show="cache_data.postal_code"></label>
            <input type="text" :id="address_name+ '_postal_code'" :placeholder="cache_data_label.postal_code" v-model="cache_data.postal_code" @change="update_formatted_address">
        </div>
        <div class="form_row form_row_controller_container">
            <input type="button" class="btn btn-primary" value="Save" @click="save(address_name)">
            <input type="button" class="btn btn-secondary-inverse" value="Cancel" @click="cancel()">
        </div>
    </div>    
</template>

<script>
    export default {
        name: "UpdateAddress",
        props: ['option','current_id'],
        data() {
            let data_set = {
                map_name: 'address',
                // following only used if global item_map not provided or global item_map does not contain country and state map
                available_countries: [
                    {'display_name':'Australia','value':'AU'},
                    {'display_name':'New Zealand','value':'NZ'},
                    {'display_name':'Canada','value':'CA'},
                    {'display_name':'China','value':'CN'},
                    {'display_name':'South Africa','value':'ZA'},
                    {'display_name':'United Kingdom','value':'GB'},
                    {'display_name':'United States','value':'US'},
                ],
                available_states:{
                    AU:[
                        {'display_name':'New South Wales','value':'NSW'},
                        {'display_name':'Victoria','value':'VIC'},
                        {'display_name':'Queensland','value':'QLD'},
                        {'display_name':'South Australia','value':'SA'},
                        {'display_name':'Western Australia','value':'WA'},
                        {'display_name':'Tasmania','value':'TAS'},
                        {'display_name':'Northern Territory','value':'NT'},
                        {'display_name':'Australian Capital Territory','value':'ACT'},
                    ]
                },
                autocomplete: null,
                google_autocomplete_input: '',
                cache_data_label: {
                    // place_id: 'Place ID',
                    formatted_address: 'Formatted Address',
                    point_of_interest: 'Care of',
                    subpremise: 'Suite/Level/Unit',
                    street_number: 'Street Number',
                    route: 'Street Name',
                    locality: 'Suburb',
                    administrative_area_level_1: 'State',
                    country: 'Country',
                    postal_code: 'Postcode'
                },
                item_map: null,
                item_list: null,
                address_name: '',
                message_option: {
                    message: '',
                    message_type: ''
                },
            };
            let current_object = this;
            data_set.cache_data = current_object.reset_cache_data({init:true});
            if (current_object.option) {
                Object.keys(current_object.option).forEach(function (option_key) {
                    data_set[option_key] = current_object.option[option_key];
                });
            }

            if (data_set.item_map) {
                if (data_set.item_map.country) {
                    data_set.available_countries = [];
                    Object.keys(data_set.item_map.country).forEach(function (country_code) {
                        data_set.available_countries.push({display_name:data_set.item_map.country[country_code],value:country_code});
                    });
                }
                if (data_set.item_map.state) {
                    data_set.available_states = {};
                    Object.keys(data_set.item_map.state).forEach(function (country_code) {
                        data_set.available_states[country_code] = [];
                        switch (country_code) {
                            case 'NZ':
                                // Countries like New Zealand, Google place short name is same as long name
                                Object.keys(data_set.item_map.state[country_code]).forEach(function (state_code) {
                                    data_set.available_states[country_code].push({display_name:data_set.item_map.state[country_code][state_code],value:data_set.item_map.state[country_code][state_code]});
                                });
                                break;
                            default:
                                Object.keys(data_set.item_map.state[country_code]).forEach(function (state_code) {
                                    data_set.available_states[country_code].push({display_name:data_set.item_map.state[country_code][state_code],value:state_code});
                                });
                        }
                    });
                }
            }
            // console.log('allen debug UpdateAddress init data',data_set);
            return data_set;
        },
        mounted() {
            let current_object = this;
            if (!current_object.item_map && current_object.$parent.item_map) {
                current_object.item_map = current_object.$parent.item_map;
            }
            if (!current_object.item_list && current_object.$parent.item_list) {
                current_object.item_list = current_object.$parent.item_list;
            }
            if (!current_object.address_name) {
                current_object.address_name = 'address_id';
            }

        },
        methods: {
            reset_cache_data: function(option) {
                if (typeof option === 'undefined') {
                    option = {};
                }

                let current_object = this;

                let cache_data = {
                    id: '',
                    place: '',              // Cache Google place object
                    place_id: '',
                    formatted_address: '',
                    full_address: '',
                    point_of_interest: '',
                    subpremise: '',
                    street_number: '',
                    route: '',
                    locality: '',
                    administrative_area_level_1: '',
                    country: 'AU',
                    postal_code: ''
                };
                if (!option.init) {
                    if (option.update_country) {
                        delete  cache_data.country;
                    }
                    current_object.cache_data = Object.assign(current_object.cache_data,cache_data);
                    cache_data = current_object.cache_data;
                }

                current_object.current = {};
                if (current_object.current_id && current_object.option) {
                    if (current_object.option.item_map[current_object.map_name][current_object.current_id]) {
                        cache_data = Object.assign(cache_data, current_object.item_map[current_object.map_name][current_object.current_id]);
                        current_object.current = current_object.item_map[current_object.map_name][current_object.current_id];
                    }
                }

                return cache_data;

            },
            update_formatted_address: function(option) {
                let current_object = this;
                let formatted_address_stack = [];
                let formatted_address_line = '';

                if (current_object.cache_data.route) {
                    formatted_address_line = current_object.cache_data.route;
                    if (current_object.cache_data.street_number) {
                        formatted_address_line = current_object.cache_data.street_number + ' ' + formatted_address_line;
                    }
                    if (current_object.cache_data.subpremise) {
                        formatted_address_line = current_object.cache_data.subpremise + '/' + formatted_address_line;
                    }
                    // if (current_object.cache_data.point_of_interest) {
                    //     formatted_address_line = current_object.cache_data.point_of_interest + ', ' + formatted_address_line;
                    // }
                    formatted_address_stack.push(formatted_address_line);
                }

                if (current_object.cache_data.locality) {
                    formatted_address_line = current_object.cache_data.locality;
                    switch (current_object.cache_data.country) {
                        case 'NZ':
                            // New Zealand omit administrative_area_level_1 in formatted address
                            break;
                        default:
                            if (current_object.cache_data.administrative_area_level_1) {
                                formatted_address_line += ' ' + current_object.cache_data.administrative_area_level_1;
                            }
                    }

                    if (current_object.cache_data.postal_code) {
                        formatted_address_line += ' ' + current_object.cache_data.postal_code;
                    }
                    formatted_address_stack.push(formatted_address_line);
                }

                if (!formatted_address_stack.length) {
                    current_object.cache_data.formatted_address = '';
                    return current_object.cache_data.formatted_address;
                }

                current_object.cache_data.place = null;
                current_object.cache_data.place_id = '';
                current_object.cache_data.formatted_address = formatted_address_stack.join(', ');

                if (current_object.cache_data.point_of_interest) {
                    formatted_address_stack.unshift('C/- '+current_object.cache_data.point_of_interest);
                }

                if (current_object.cache_data.country && current_object.cache_data.country !== 'AU') {
                    if (current_object.$root.item_map && current_object.$root.item_map.country && current_object.$root.item_map.country[current_object.cache_data.country]) {
                        formatted_address_stack.push(current_object.$root.item_map.country[current_object.cache_data.country]);
                    } else {
                        formatted_address_stack.push(current_object.cache_data.country);
                    }
                }
                current_object.cache_data.full_address = formatted_address_stack.join(', ');

                return current_object.cache_data.formatted_address;
            },
            init_autocomplete: function ($event) {
                let current_object = this;

                if (!current_object.autocomplete) {
                    current_object.autocomplete = new google.maps.places.Autocomplete($event.target, {
                        componentRestrictions: { country: [current_object.cache_data.country] },
                        fields: ['place_id', 'address_components', 'formatted_address'],
                        types: ['address'],
                    });

                    current_object.autocomplete.addListener('place_changed', this.fill_google_address);
                } else {
                    current_object.autocomplete.setOptions({
                        componentRestrictions: { country: [current_object.cache_data.country] }
                    })
                }
            },
            fill_google_address: function () {
                let current_object = this;

                if (!current_object.autocomplete) {
                    message_option.message_type = 'warning';
                    message_option.message = 'Failed to load '+address_name+' autocomplete';
                } else {
                    let place = current_object.autocomplete.getPlace();

                    current_object.reset_cache_data();

                    current_object.cache_data.place = place;
                    current_object.cache_data.place_id = place.place_id;
                    current_object.cache_data.formatted_address = place.formatted_address;
                    current_object.cache_data.full_address = place.formatted_address;
                    current_object.google_autocomplete_input = '';

                    for (const component of place.address_components) {
                        // @ts-ignore remove once typings fixed
                        const componentType = component.types[0];

                        if (componentType in current_object.cache_data) {
                            if (componentType === 'route') {
                                current_object.cache_data[componentType] = component.long_name;
                            } else {
                                current_object.cache_data[componentType] = component.short_name;
                            }
                        } else {
                            // if (componentType === 'point_of_interest' || componentType === 'sublocality_level_1') {
                            //     current_object.cache_data['subpremise'] = component.short_name + ', ' + current_object.cache_data['subpremise'];
                            // }
                            if (componentType === 'sublocality_level_1') {
                                if (current_object.cache_data['point_of_interest']) {
                                    current_object.cache_data['point_of_interest'] = component.short_name + ', ' + current_object.cache_data['point_of_interest'];
                                } else {
                                    current_object.cache_data['point_of_interest'] = component.short_name;
                                }
                            }
                        }
                    }
                }
            },
            save: function () {
                let current_object = this;

                let warning_message = [];

                // General Validation, e.g. mandatory field empty, number format wrong...
                Object.keys(current_object.cache_data).forEach(function (field_name) {
                    switch (field_name) {
                        case 'route':
                        case 'locality':
                        case 'administrative_area_level_1':
                        case 'postal_code':
                            if (current_object.cache_data[field_name] === '') {
                                warning_message.push('Field "'+current_object.cache_data_label[field_name]+'" is required.');
                            }
                            break;
                    }
                });

                if (warning_message.length > 0) {
                    // current_object.display_message(warning_message,{message_type:'error'});
                    current_object.message_option.message_type = 'error';
                    current_object.message_option.message = warning_message;
                    return false;
                } else {
                    // current_object.display_message('');
                    current_object.message_option.message_type = 'success';
                    current_object.message_option.message = '';
                }

                /*current_object.cache_data.formatted_address = '';
                let formatted_address_stack = [];
                Object.keys(current_object.cache_data).forEach(function (key) {
                    switch (key) {
                        case 'country':
                        case 'formatted_address':
                        case 'id':
                            break;
                        default:
                            if (current_object.cache_data[key]) {
                                formatted_address_stack.push(current_object.cache_data[key]);
                            }
                    }
                });
                current_object.cache_data.formatted_address = formatted_address_stack.join(', ');*/
                let index_counter = 1;
                if (!current_object.item_map[current_object.map_name]) {
                    current_object.item_map[current_object.map_name] = {};
                }
                if (!current_object.item_list[current_object.map_name]) {
                    current_object.item_list[current_object.map_name] = [];
                }
                while (current_object.item_map[current_object.map_name]['new_'+index_counter]) {
                    index_counter++;
                }
                current_object.cache_data.id = 'new_'+index_counter;
                current_object.item_map[current_object.map_name]['new_'+index_counter] = Object.assign({},current_object.cache_data);
                current_object.item_list[current_object.map_name].push(current_object.item_map[current_object.map_name]['new_'+index_counter]);

//
//                 let i = 1;
//                 let j = 0;
//                 let duplicate_flag = true;
//                 while (duplicate_flag) {
//                     duplicate_flag = false;
//                     for (j=0;j<current_object.item_list.addresses.length;j++) {
//                         if (current_object.item_list.addresses[j]['id'] == 'new_'+i) {
//                             i++;
//                             duplicate_flag = true;
//                             break;
//                         }
//                     }
//                 }
//                 current_object.cache_data.id = 'new_'+i;
// console.log('apply new address',current_object.item_list.addresses,current_object.cache_data);
//                 current_object.item_list.addresses.push(current_object.cache_data);
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550);
                // current_object.$emit('update:new_address',this.cache_data.id,this.option.address_name);
                current_object.$emit('update:new_address',current_object.cache_data.id,current_object.address_name,'submit');
                current_object.reset_cache_data();
            },
            cancel: function () {
                let current_object = this;
                $('html, body').stop().animate({
                    scrollTop:$(current_object.$el).offset().top - 200
                }, 550);
                current_object.$emit('update:new_address','',current_object.address_name,'cancel');
                current_object.reset_cache_data();
            }
        }
    }
</script>